// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__24gR_","tab":"ProcedureTabs_tab__3c_iw"};